export interface DLMWebPhase0DetailsModel {
  id: number	// integer($int64)
  itemNo: string
  size: string
  hourRating: string
  labelFrom: string
  labelTo: string
  remarks: string
  quantity: number	// integer($int32)
  targetDetailId: number	// integer($int64)
  targetLabels: Array<string>
  doorType: string
  visionPanel: boolean
}


export interface DLMWebPhase0SitesModel {
  id: number	// integer($int64)
  installerName: string
  projectName: string
  projectLocation: string
  coverageArea: string
  hourRating: string
  unit: string
  bpNumber: string
  clientRefNo: string
  otherReference: string
  prototypeTestReport: number	// integer($int64)
  trainingRecord: number	// integer($int64)
  methodOfStatement: number	// integer($int64)
  productConstructionDrawing: number	// integer($int64)
  sitePlanDrawing: number	// integer($int64)
  siteChecklist: number	// integer($int64)
  setscoROI: number	// integer($int64)

  dlmWebPhase0DetailsModels: Array<DLMWebPhase0DetailsModel>
}

export interface DLMWebPhase0Model {
  id: number	// integer($int64)
  applicationType: string
  dlmType: number	// integer($int64)
  labelSet: number	// integer($int64)
  applicationCertificate: number	// integer($int64)
  model: string
  hourRating: string
  projectName: string
  projectLocation: string
  scdfProjectPlanNo: string
  installerName: string
  podo: number	// integer($int64)
  otherAttachments: Array<number>
  sirSelected: Array<number>
  sirSelectedText: string
  approvalAttachment: number	// integer($int64)
  doHolder: number	// integer($int64)
  poHolder: number	// integer($int64)
  caHolder: number	// integer($int64)
  labelRecord: number	// integer($int64)
  comment: string
  percentCompletion: number	// integer($int32)
  samplingLocation: string
  coverageArea: string
  unit: string
  totalLabelQuantity: number	// integer($int32)
  clientRefNo: string
  componentLocation: string
  poNO: string
  dlmWebPhase0SitesModel: Array<DLMWebPhase0SitesModel>
  targetROI: number	// integer($int64)
  targetDOC: number	// integer($int64)
  docSplitArea: string
  policeReport: number	// integer($int64)

  // not in swagger
  applicationTypeLP: string
  targetLabels: Array<number> // integer($int64)]
}

export interface IDLMWebDOCModel {
  docId: number  //: number	// integer($int64)
  docAttachmentId: number  //: number	// integer($int64)
  siteApplicationId: number  //: number	// integer($int64)
  inspectionId: number  //: number	// integer($int64)
  issueDate: string // date-time
  cbRef: string
  companyName: string
  installer: string
  projectName: string
  planNo: string
  otherRef: string
  productType: string
  cocNo: string
  brand: string
  model: string
  areaOfCoverage: number  //	number($double)
  unit: string
  hourRating: string
  location: string
  hasIssueDate: boolean
}

export const initDLMWebDOCModelValues = {
  docId: 0,
  docAttachmentId: 0,
  siteApplicationId: 0,
  inspectionId: 0,
  issueDate: '',
  cbRef: '',
  companyName: '',
  installer: '',
  projectName: '',
  planNo: '',
  otherRef: '',
  productType: '',
  cocNo: '',
  brand: '',
  model: '',
  areaOfCoverage: 0,
  unit: '',
  hourRating: '',
  location: '',
  hasIssueDate: false
}

export interface IDLMWebLabelModel {
  id: number //: number	// integer($int64)
  serialNumber: number    //: number	// integer($int32)
  remarks: string
  state: string
}


export const initDLMWebLabelModelValues = {
  id: 0,
  serialNumber: 0,
  remarks: '',
  state: ''
}


export interface IDLMWebROIDetailsModel {
  id: number   //: number	// integer($int64)
  itemNo: string
  size: string
  model: string
  type: string
  hourRating: string
  labelFrom: string
  labelTo: string
  quantity: number   //: number	// integer($int32)
  doorType: string
  remarks: string
  visionPanel: boolean
  labels: Array<IDLMWebLabelModel>
  draftLabels: Array<IDLMWebLabelModel>
}

export interface IDLMWebROIModel {
  roiId: number   //: number	// integer($int64)
  roiAttachmentId: number   //: number	// integer($int64)
  inspectionId: number   //: number	// integer($int64)
  siteApplicationId: number   //: number	// integer($int64)
  cocHolderRef: string
  cocHolder: string
  cocHolderAddress: string
  installerCompany: string
  cocNo: string
  brand: string
  model: string
  country: string
  projectName: string
  planNo: string
  series: string
  otherRef: string
  type: string
  no: number   //: number	// integer($int32)
  quantity: string
  serial: string
  revision: number   //: number	// integer($int32)
  split: number   //: number	// integer($int32)
  roiDetails: Array<IDLMWebROIDetailsModel>
  getcbRef: string
}




export const initDLMWebROIModelValues: IDLMWebROIModel = {
  roiId: 0,
  roiAttachmentId: 0,
  inspectionId: 0,
  siteApplicationId: 0,
  cocHolderRef: '',
  cocHolder: '',
  cocHolderAddress: '',
  installerCompany: '',
  cocNo: '',
  brand: '',
  model: '',
  country: '',
  projectName: '',
  planNo: '',    
  series: '',
  otherRef: '',
  type: '',
  no: 0,
  quantity: '',
  serial: '',
  revision: 0,
  split: 0,
  roiDetails: [],
  getcbRef: '',
}

export const initDLMWebROIDetailsModelValues = {
  id: 0,
  itemNo: '',
  size: '',
  model: '',
  type: '',
  hourRating: '',
  labelFrom: '',
  labelTo: '',
  quantity: 0,
  doorType: '',
  remarks: '',
  visionPanel: false,
  labels: [],
  draftLabels: [],
}
